import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AutocompleteRenderInputParams, FormInputText, InputLabel, Select } from '@hopskipdrive/react-components';
import { AutocompleteRenderGroupParams, ListSubheader } from '@mui/material';

import { JobTitleOption } from '../../hooks/useJobTitles';

interface JobTitleFormFieldProps {
  jobTitleOptions: JobTitleOption[];
  isFetching: boolean;
  isRequired: boolean;
}

export const JobTitleFormField: FC<JobTitleFormFieldProps> = ({ jobTitleOptions, isFetching, isRequired }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <InputLabel fieldtype={isRequired ? 'required' : undefined} htmlFor="jobTitle" id="jobTitle-label">
        Job Title
      </InputLabel>
      <Controller
        control={control}
        name="jobTitle"
        defaultValue=""
        render={({ field: { value, onChange } }) => (
          <Select
            id="jobTitle"
            options={jobTitleOptions}
            value={jobTitleOptions.length ? value : null}
            setValue={(newValue) => onChange(newValue ? newValue : null)}
            isLoading={isFetching}
            groupBy={(option) => (option as JobTitleOption).group}
            renderGroup={(params: AutocompleteRenderGroupParams) => (
              <li key={params.key}>
                <ListSubheader
                  component="div"
                  className="MuiAutocomplete-groupLabel"
                  sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                  {params.group}
                </ListSubheader>
                <ul className="MuiAutocomplete-groupUl">{params.children}</ul>
              </li>
            )}
            renderInput={(params: AutocompleteRenderInputParams) => (
              <FormInputText
                {...params}
                variant="outlined"
                fullWidth
                data-testid="jobTitle"
                placeholder="Select"
                error={!!errors.jobTitle}
                helperText={errors.jobTitle?.message as string}
                inputProps={{
                  ...params.inputProps,
                  'aria-labelledby': 'jobTitle-label',
                }}
              />
            )}
          />
        )}
      />
    </>
  );
};
